import Image from "next/image";
import Link from "next/link";
import Head from "next/head";
import interviewwebbanner from "../../assets/images/upsc/interview/IFS-Interview-webbanner.jpg";
import Mobban from "../../assets/images/upsc/interview/IFS-Interview-Mobbanner.jpg";
import NewiconA from "../../assets/images/header/pdf.png";
import handIcon from "../../assets/images/header/touch-01.png";
import modal from "../../assets/images/interview2022/modal.png";
import interview from "../../assets/images/interview2022/interview.png";
import books from "../../assets/images/interview2022/books.png";
import brochure from "../../assets/images/interview2022/brochure.png";
import pin from "../../assets/images/interview2022/pin.svg";
import medal from "../../assets/images/home/medal.webp";
import styles from "./upsc-interview.module.css";
import Navbar from "../../components/Navbar/Navbar";

import Footer from "../../components/Footer/Footer";
import dynamic from "next/dynamic";
const Interest = dynamic(()=>import("../../components/might-be-interest"));
const Acheiver = dynamic(() => import("../../components/our-acheiver/achievers"));
//import Interview_2022_Free_Coaching_Form from "./upsc-interview-form";
//const pic10045 = "../../assets/images/Result/10045.webp";
//const pic10018 = "../../assets/images/Result/10018.webp";
//const pic10068 = "../../assets/images/Result/10068.webp";
//const pic10019 = "../../assets/images/Result/10019.webp";
//const pic10015 = "../../assets/images/Result/10015.webp";
const Interview_2022_Free_Coaching = () => {

  const steps = [
  // {
  //   title: "One-on-One Sessions",
  //   desc: "Individual interviews with detailed feedback.",
  // },
  // {
  //   title: "Panel Mocks with Bureaucrats",
  //   desc: "Serving and retired officers simulate the real UPSC board.",
  // },
  // {
  //   title: "Group-Based DAF Profiling",
  //   desc: "Learn how your background may be questioned.",
  // },
  {
    title: "Current Affairs Sessions",
    desc: "Polity, Economy, Health, National Security, Social Justice, Women & Children, Foreign Policy, Agriculture, Environment, Energy, Industry, and more.",
  },
  {
    title: "Pre-Mock SWOT Analysis",
    desc: "Identify strengths and weaknesses before your main mock.",
  },
  {
    title: "Mentorship by Young Bureaucrats",
    desc: "Guidance from recently selected officers who know the process.",
  },
  {
    title: "Comprehensive Feedback Report",
    desc: "Insights on body language, confidence, and communication skills, with practical tips for improvement.",
  },
];

  const jsonLd ={
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "UPSC Interview Registration | Shankar IAS Academy",
    "url": "https://www.shankariasacademy.com/upsc-interview/",
    "Image": "https://www.shankariasacademy.com/_next/static/media/upsc.a9958312.jpg",
    "description": "Secure your spot! UPSC Interview Registration 2025 now open. Ace the final stage. Register today for a chance to join the ranks of excellence."
  }

  return (  
    <>

        <Head>
            <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd,null, "\t") .replaceAll("],\n\t\"", "],\n\n\t\"") }} />
            <meta charset="UTF-8" />
            
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta name="robots" content="noodp,noydir" />
            <meta name="robots" content="index,follow" />
            <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
            <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
            <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
            <title>UPSC Interview Registration | Shankar IAS Academy</title>
            <meta name="title" content="IAS Personality Test 2025 | UPSC Mock Interview with Bureaucrats | UPSC IAS Mock Interview 2025 | UPSC Personality Test Coaching & DAF Analysis " />
            <meta name="description" content=" Book your UPSC IAS mock interview 2025 at Shankar IAS Academy. Get one-on-one sessions, DAF profiling, and feedback from serving & retired bureaucrats." />
            <link rel="canonical" href="https://www.shankariasacademy.com/upsc-interview/" />
            <meta property="og:locale" content="en_US" />
            <meta property="og:type" content="article" />
            <meta property="og:title" content="IAS Personality Test 2025 | UPSC Mock Interview with Bureaucrats | UPSC IAS Mock Interview 2025 | UPSC Personality Test Coaching & DAF Analysis" />
            <meta property="og:description" content="Book your UPSC IAS mock interview 2025 at Shankar IAS Academy. Get one-on-one sessions, DAF profiling, and feedback from serving & retired bureaucrats." />
            <meta property="og:url" content="https://www.shankariasacademy.com/upsc-interview/" />
            <meta property="og:site_name" content="Shankar IAS Academy" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site" content="@shankarias" />
        </Head>

    <Navbar title="upsc" />

<div className="container">
  <div className="row">
    <div className="col pt-3 pt-md-4">
      <h1 className={`${styles.pagemaintitle}`}>UPSC Civil Service Interview 2025-2026</h1>
    </div>
  </div>

  <div className = "row d-none d-md-block">
      <div className="col">
          <Image
              src={interviewwebbanner}
              className="img-fluid w-100"
              alt="upsc-interview Banner"
              title="Interview 2025 - Free Coaching" 
            />
      </div>
  </div>

  <div className = "row d-block d-md-none">
      <div className="col">
            <Image
                src={Mobban}
                className="img-fluid w-100"
                alt="upsc-interview Banner"
                title="Interview 2025 - Free Coaching" 
              />
      </div>
  </div>
</div>

  {/* Desktop view */}
<div className="container pt-4">
    <div className="row d-none d-md-none d-lg-block ">
      <div className={`${styles.interviewbg}`}>
       <div className="d-flex justify-content-end py-3 ">
        <Link href="https://admissionsv1.shankariasacademy.com/civilisation-interview/" target="_blank" className={`${styles.btnbox}`}>
          <p className="pt-3">UPSC Interview Registration 2026</p>
          <button className={`${styles.normalbutton} mb-3`}>Click Here
            <Image
               src={handIcon}
               alt="PDF Icon"
               width={32}
               height={32}
               className={styles.blinkingIcon}
             />
          </button>
        </Link>
      </div> 
<div className="d-flex justify-content-end py-3 ">
        <Link href="https://admissionsv1.shankariasacademy.com/forestry/" target="_blank" className={`${styles.btnbox}`}>
          <p className="pt-3">UPSC IFS (Forest Service) Interview <br />Registration 2026</p>
          <button className={`${styles.normalbutton} mb-3`}>Click Here
            <Image
               src={handIcon}
               alt="PDF Icon"
               width={32}
               height={32}
               className={styles.blinkingIcon}
             />
          </button>
        </Link>
      </div> 
       {/* <div className= {`${styles.bluetxt1}`}>
        <Link href="https://www.shankariasacademy.com/pdf/Interview-2025/Interview-Schedule-Final-2025.pdf" target="_blank">
        <button className={`${styles.redbtn}`}>UPSC Civils Interview Schedule 2026  <Image src={NewiconA} alt="download icon"  className={`${styles.downloadicon}`}/></button>
        </Link>
      </div> */}

        <p className={`${styles.bluetxt} pt-2`}>SHANKAR IAS ACADEMY EDGE!</p>
     
      </div> 
    </div>
</div>


{/*Medium  Device*/}

  <div className="container pt-4">
    <div className="row d-none d-md-block d-lg-none">
    
      <div className="d-flex justify-content-center py-3 py-md-5">
        <Link href="https://admissionsv1.shankariasacademy.com/civilisation-interview/" target="_blank" className={`${styles.btnbox}`}>
          <p className="pt-3">UPSC Interview Registration 2025</p>
          <button className={`${styles.normalbutton} mb-3`}>Click Here
            <Image
               src={handIcon}
               alt="PDF Icon"
               width={32}
              height={32}
              className={styles.blinkingIcon}
             />
          </button>
        </Link>
      </div>
      <div className="justify-content-center">
      <p className={`${styles.bluetxt}`}>SHANKAR IAS ACADEMY EDGE!</p>
      <div className= {`${styles.bluetxt1}`}>
        <Link href="https://www.shankariasacademy.com/pdf/Interview-2025/Interview-Schedule-Final-2025.pdf" target="_blank">
        <button className={`${styles.redbtn}`}>UPSC Civils Interview Schedule 2025  <Image src={NewiconA} alt="download icon"  className={`${styles.downloadicon}`}/></button>
        </Link>
      </div>
     </div>
    </div>
  </div>

{/*Mobile View*/}

<div className="container">
    <div className="row  d-block d-md-none">
    <div className="d-flex justify-content-center py-3 py-md-5">
       <Link href="https://admissionsv1.shankariasacademy.com/civilisation-interview/" target="_blank" className={`${styles.btnbox1}`}>
        <p className="pt-3">UPSC Interview Registration 2025</p>
        <button className={`${styles.normalbutton} mb-3`}>Click Here
          <Image
               src={handIcon}
               alt="PDF Icon"
               width={32}
              height={32}
              className={styles.blinkingIcon}
             />
        </button>

      </Link> 
       
    </div>
      <p className={`${styles.mobtxt}`}>SHANKAR IAS ACADEMY EDGE!</p>
    <div className= {`${styles.mobtxt} justify-content-center`}>
      <Link href="https://www.shankariasacademy.com/pdf/Interview-2025/Interview-Schedule-Final-2025.pdf" target="_blank">
       <button className={`${styles.redbtn1}`}>UPSC Civils Interview Schedule 2025  <Image src={NewiconA} alt="download icon"  className={`${styles.downloadicon}`}/></button>
      </Link>
    </div>
    </div> 
  </div>


 {/*<Interview_2022_Free_Coaching_Form /> */}



<div className="container pt-5">
<div className="row">
  <div className="col">
  <h2 className={`${styles.sectiontitle}`}>Why Interview Prep Matters</h2> 
  <p className={`${styles.acheiverrank} mb-0`}>
    The UPSC interview, also known as the Personality Test, is worth 275 marks and can change your final ranking and service allocation. At Shankar IAS Academy, we prepare you for this stage where, besides knowledge, what matters is clarity of thought, confidence in expression, and composure in the room. 
  </p>
  </div>
</div>
</div>

<div className="container pt-3">
<div className="row">
    
      <div className="col-md-4 mb-3 mb-md-4 col-12 text-center">
        <div className={`${styles.facultyborder1} p-5 p-md-4 p-xl-5 h-100`}>
        <Image
              src={modal}
              className="img-fluid"
              alt="interview session"
              title="Session"

            />
        <p className={`${styles.acheiverrank} text-center mb-0`}>One-on-One Sessions</p>
        <p className={`${styles.acheiverrank} text-center mb-0`}>Individual interviews with detailed feedback.</p>
      </div>
      </div>
  
      <div className="col-md-4 mb-3 mb-md-4 col-12 text-center">
        <div className={`${styles.facultyborder1} p-5 p-md-4 p-xl-5 h-100`}>
        <Image
              src={interview}
              className="img-fluid"
              alt="interview session"
              title="Session"

            />
        <p className={`${styles.acheiverrank} text-center mb-0`}>Panel Mocks with Bureaucrats</p>
        <p className={`${styles.acheiverrank} text-center mb-0`}>Serving and retired officers simulate the real UPSC board.</p>
        </div>
        </div>
        
          <div className="col-md-4 mb-3 mb-md-4 col-12 text-center">
            <div className={`${styles.facultyborder1} p-5 p-md-4 p-xl-5 h-100`}>
        <Image
              src={books}
              className="img-fluid"
              alt="interview session"
              title="Session"

            />
        <p className={`${styles.acheiverrank} text-center mb-0`}>Group-Based DAF Profiling</p>
        <p className={`${styles.acheiverrank} text-center mb-0`}>Learn how your background may be questioned.</p>
        </div>
        </div>

</div>
</div>
 
{/* <div className="container pt-2">
<div className="row">

  <div className="col-md-6 mb-3 mb-md-4">
    <div className={`${styles.aboutbox1} p-4 h-100`}>
      <div className="row">
        <div className="col-lg-3 col-md-4 col-5">
        <Image
              src={brochure}
              className="img-fluid"
              alt="Brochure icon"
              title="Brochure"
            />
        </div>
          <div className="col-lg-9 col-md-8 col-7 ps-0">
            <p className={`${styles.sectionsubtitle} mb-0`}>Tamilnadu, Bengaluru,</p>
            <p className={`${styles.sectionsubtitle} mb-2`}>Thiruvananthapuram and Online</p>
            <a href="https://www.shankariasacademy.com/pdf/Interview-2024/Interview-Schedule-Final1-2024.pdf" target={"_blank"} className={`${styles.redunderlinealink}`} style={{whiteSpace: "nowrap"}}>Download Brochure</a>
          </div>          
      </div>
    </div>
  </div>

  <div className="col-md-6 mb-3 mb-md-4">
    <div className={`${styles.aboutbox1} p-4 h-100`}>
      <div className="row">
        <div className="col-lg-3 col-md-4 col-5">
        <Image
              src={brochure}
              className="img-fluid"
              alt="Brochure icon"
              title="Brochure"
            />
        </div>
          <div className="col-lg-9 col-md-8 col-7 ps-0 my-lg-3 my-0">
            <p className={`${styles.sectionsubtitle} mb-2`}>Delhi branch</p>
            <a href="https://www.shankariasacademy.com/pdf/Interview-2024/Interview-Schedule-Final1-2024.pdf" target={"_blank"} className={`${styles.redunderlinealink}`} style={{whiteSpace: "nowrap"}}>Download Brochure</a>
          </div>          
      </div>
    </div>
  </div>

</div>
</div> */}

<div className="container pt-2">
  <div className="row">
      <div className="col">
        <h3 className={`${styles.pagemaintitle1}`}>With the right guidance, aspirants can:</h3>
        
          <p className={`${styles.acheiverrank} mb-2`}><span className={`${styles.dot} pe-2`}>* </span>Sharpen your confidence and body language to leave a strong impression.</p>
          <p className={`${styles.acheiverrank} mb-2`}><span className={`${styles.dot} pe-2`}>* </span>Anticipate and handle DAF-based & current affairs questions with ease.</p>
          <p className={`${styles.acheiverrank} mb-2`}><span className={`${styles.dot} pe-2`}>* </span>Learn proven strategies from toppers and apply them in practice.</p>
          <p className={`${styles.acheiverrank} mb-2`}><span className={`${styles.dot} pe-2`}>* </span>Turn feedback into visible improvements that reflect in your responses.</p>
          <p className={`${styles.acheiverrank} mb-2`}><span className={`${styles.dot} pe-2`}>* </span>Project the personality of a future civil servant - balanced, confident, service-oriented </p>
          <p className={`${styles.acheiverrank} mb-2`}><span className={`${styles.dot} pe-2`}>* </span>Maximize your 275-mark opportunity, turning the interview into a rank-booster.</p>
          
      </div>
  </div>
</div>

<div className="container py-5">
      {/* Title */}
      <div className="text-center mb-5">
        <h3 className={`${styles.pagemaintitle1}`}>
          What You’ll Get in Our <span className="text-danger">Mock Interview Programme</span>
        </h3>
        <p className="text-muted lead">
          Get complete guidance to face the UPSC Personality Test with confidence.
        </p>
      </div>

      <div className="position-relative mx-auto" style={{ maxWidth: "600px" }}>
        {/* Center vertical line */}
        <div
          className="position-absolute top-0 start-50 translate-middle-x"
          style={{ width: "4px", height: "100%", background: "#e9ecef" }}
        ></div>

        <ul className="list-unstyled m-0 p-0">
          {steps.map((step, index) => (
            <li key={index} className="position-relative mb-5">
              {/* Circle connector */}
              <div
                className="position-absolute start-50 translate-middle rounded-circle shadow"
                style={{
                  width: "40px",
                  height: "40px",
                  top: "0",
                  background: "#c50101",
                  color: "#fff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: "bold",
                  zIndex: 1,
                }}
              >
                ✓
              </div>

              {/* Card */}
              <div
                className="bg-white shadow p-4 rounded-3 text-center mx-auto"
                style={{ width: "90%", marginTop: "20px" }}
              >
                <h5 className="fw-bold text-dark">{step.title}</h5>
                <p className="text-muted mb-0">{step.desc}</p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
    
<div className="container pt-2">
  <div className="row">
      <div className="col">
        <h3 className={`${styles.pagemaintitle1}`}>Meet Our Panelists & Mentors</h3>

          <p  className="text-muted lead">At Shankar IAS Academy, your interview will be conducted by a panel of eminent personalities, including:</p>

          <p className={`${styles.acheiverrank} mb-2`}><span className={`${styles.dot} pe-2`}>* </span>Retired IAS, IPS, and IFS officers</p>
          <p className={`${styles.acheiverrank} mb-2`}><span className={`${styles.dot} pe-2`}>* </span>Serving bureaucrats with first-hand experience.</p>
          <p className={`${styles.acheiverrank} mb-2`}><span className={`${styles.dot} pe-2`}>* </span>Subject experts in Economics, Polity, Security, and International Relations.</p>
      </div>
  </div>
</div>
    

<div className="container pt-3">

<h4 className={`${styles.pagemaintitle1} mb-3`}>Our Centers</h4>

<div className="row">     
  <div className="col-lg-2">
  <p className={`${styles.acheiverrank}`}>
            <Image
              src={pin}
              className="img-fluid"
              alt="Chennai location"
              title="Chennai location"

            />&nbsp;&nbsp;&nbsp;&nbsp;Chennai</p>          
  </div>
  <div className="col-lg-2">
  <p className={`${styles.acheiverrank}`}>
            <Image
              src={pin}
              className="img-fluid"
              alt="Delhi location"
              title="Delhi location"

            />&nbsp;&nbsp;&nbsp;&nbsp;Delhi</p> 
  </div>
  <div className="col-lg-2">
  <p className={`${styles.acheiverrank}`}>
            <Image
              src={pin}
              className="img-fluid"
              alt="Bengaluru location"
              title="Bengaluru location"

            />&nbsp;&nbsp;&nbsp;&nbsp;Bengaluru</p> 
  </div>
  <div className="col-lg-3">
  <p className={`${styles.acheiverrank}`}>
            <Image
              src={pin}
              className="img-fluid"
              alt="Thiruvananthapuram location"
              title="Thiruvananthapuram location"

            />&nbsp;&nbsp;&nbsp;&nbsp;Thiruvananthapuram</p> 
  </div>
  <div className="col-lg-2">
  <p className={`${styles.acheiverrank}`}>
            <Image
              src={pin}
              className="img-fluid"
              alt="Hyderabad location"
              title="Hyderabad location"

            />&nbsp;&nbsp;&nbsp;&nbsp;Hyderabad</p> 
  </div>

</div>
</div>

<div className="container-fluid pt-md-5 pt-4 px-0">
  <div className="row mx-auto"> 
    <div className={`${styles.bground} mb-5`}>
      <div className="container">
      <div className="row">
        <div className="col text-center">
              <Image
                src={medal}
                className="img-fluid"
                alt="medal icon"
                title="Medal"
              />
        </div>
      </div>
      </div>

      <div className="container pt-4">
        <div className="row">
            <div className="col">
              <h4 className={`${styles.pagemaintitle1} text-center mb-0`}>Our Achievers</h4>
              <h4 className={`${styles.sectionsubtitle1} text-center`} style={{whiteSpace: "nowrap"}}>Rank Holders from our academy</h4>
            </div>
        </div>
      </div>   
    </div>
  </div>
</div>

<div className="container">
<div className="row">
  <div className="col">
     <Acheiver />
  </div>
</div>
</div>

<Interest />

    <Footer />
    </>
  )
}

export default Interview_2022_Free_Coaching
